export const DateFormat = Object.freeze({
	Server: 'Y-m-d',
	ServerParse: 'YYYY-MM-DD',
	WeekDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
});
